export const BREAKPOINTS = {
    MOBILE: 768,
    TABLET: 1024,
};